export default {"src":"/_next/static/media/ThreeUsers.709b50ed.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};